import { List } from "@bookingcom/bui-react";
import React from "react";
import Frame from "../Frame/index.js";
import { FlightCampaignTCBanner } from "../FlightCampaignTCBanner/index.js";
import { RemoteAppleCardSR } from "../../remote/index.js";
import useSearchResultsListDesktopController from "./useSearchResultsList.desktop.controller.js";
import FlightCardWrapper from "./FlightCardWrapper.js";
import FlightCardDesktop from "../FlightCard/FlightCard.desktop.js";
const SearchResultsListOutboundDesktop = ({ flights, onSelectFlight }) => {
    const { campaignBanner, remoteBanners } = useSearchResultsListDesktopController();
    return (React.createElement(List, { attributes: { style: { padding: 0 } } },
        flights.map((flight, index) => {
            return (React.createElement("div", { key: `${index}_${flight.token}` },
                campaignBanner && index === campaignBanner.position ? (React.createElement(Frame, { mt: 2, mb: 4 },
                    React.createElement(FlightCampaignTCBanner, { campaignBanner: campaignBanner }))) : null,
                Array.isArray(remoteBanners) &&
                    remoteBanners.includes("APPLE_CARD_BANNER_SR") &&
                    index === flights.length - 1 ? (React.createElement(RemoteAppleCardSR, null)) : undefined,
                React.createElement(FlightCardWrapper, { index: index, total: flights.length },
                    React.createElement(FlightCardDesktop, { flight: flight, index: index, onClick: onSelectFlight })),
                campaignBanner &&
                    campaignBanner.position >= flights.length &&
                    index >= flights.length - 1 ? (React.createElement(Frame, { mt: 2, mb: 4 },
                    React.createElement(FlightCampaignTCBanner, { campaignBanner: campaignBanner }))) : null));
        }),
        " "));
};
export default React.memo(SearchResultsListOutboundDesktop);
